<template>

    <div class="pin-top">

        <!-- Top navbar -->
        <navbar-header
            :classList="['bg-danger', 'text-light']"
            :right="'close-mpl'">
        </navbar-header>

        <!-- Prompt Layout -->
        <prompt-div class="text-light">

            <!-- Layout body -->
            <template v-slot:body>
                <img alt="" src="/images/illustration-error.svg">
                <div class="pt-9">
                    <h2 class="font-xl font-weight-bold">Oops!<br/>Page not found</h2>
                    <h4 class="font-md mt-5">We're sorry but we cant find the page you are looking for.</h4>
                </div>
            </template>

            <!-- Bottom button -->
            <template v-slot:bottom-button>
                <button class="btn btn-lg btn-inverted btn-block" @click="$root.goBackTo()">Go Back <img src="/images/icon-btn-next-green.svg"/></button>
            </template>

        </prompt-div>

    </div>

</template>

<script>
    export default {
        beforeCreate: function() {
            document.body.className = 'bg-danger';
        },
    }
</script>
